// File: /src/components/LogoutButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Header.css';

function LogoutButton({ variant = 'default' }) {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const className =
		variant === 'ghost' ? 'header-ghost-button' : 'logout-button';

	const handleLogout = () => {
		logout();
		navigate('/login', { replace: true });
	};

	return (
		<button className={className} onClick={handleLogout} type="button">
			Sair
		</button>
	);
}

export default LogoutButton;
